import { render } from "./lowVer.vue?vue&type=template&id=0b924f8d&scoped=true"
import script from "./lowVer.vue?vue&type=script&lang=js"
export * from "./lowVer.vue?vue&type=script&lang=js"

import "./lowVer.vue?vue&type=style&index=0&id=0b924f8d&lang=scss&scoped=true"

import exportComponent from "D:\\客云\\newQsProject\\qs3_pc_portal\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b924f8d"]])

export default __exports__